// extracted by mini-css-extract-plugin
module.exports = {"logo-grid":"LogosGrid_logo-grid__R7p_3"};